import React from 'react';
import { useIntl } from 'umi';

import './index.scss';

function JoinXboxGamePassDateCard({ time }: { time: string }) {
  const { formatMessage } = useIntl();

  return (
    <div className="dbi-join-xbox-game-date-container">
      <div className="dbi-join-xbox-game-date-text">
        {formatMessage({ id: 'dbi_date_joined_xbox_game_pass' })}
      </div>
      <div className="dbi-join-xbox-game-date-time">{time || '-'}</div>
    </div>
  );
}

export default JoinXboxGamePassDateCard;
